type EventHandler<T> = (event: T) => void;
type HandlerCleanup = () => void;

export interface EventEmitterInterface<T = void> {
  /**
   * @returns Function to detach this handler.
   */
  addHandler(handler: EventHandler<T>): HandlerCleanup;
  removeHandler(handler: EventHandler<T>): void;
}

export default class EventEmitter<T = void>
  implements EventEmitterInterface<T>
{
  private handlers: EventHandler<T>[] = [];

  get hasHandlers() {
    return this.handlers.length > 0;
  }

  addHandler(handler: EventHandler<T>): HandlerCleanup {
    if (!handler) throw new Error("Handler required.");
    this.handlers.push(handler);
    return () => this.removeHandler(handler);
  }

  removeHandler(handler: EventHandler<T>) {
    if (!handler) throw new Error("Handler required.");
    this.handlers = this.handlers.filter((h) => h !== handler);
  }

  emit(event: T) {
    this.handlers.forEach((h) => h(event));
  }
}
